import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InsLoginOtpService } from './ins-login-otp.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ins-login-otp',
  templateUrl: './ins-login-otp.component.html',
  styleUrls: ['./ins-login-otp.component.scss']
})
export class InsLoginOtpComponent implements OnInit, OnDestroy {

  @ViewChild('getOtpButton') getOtpButton!: ElementRef;
  @ViewChild('verifyOtpButton') verifyOtpButton!: ElementRef;
  hasScrolledToVerifyButton = false;
  hasScrolledToButton = false;

  mobileNumber: string = '';
  showError: boolean = false;
  otpSent: boolean = false;
  otp: string[] = ['', '', '', ''];
  timer: number = 60;
  interval: any;
  quotationId: string = '';
  spareGarageId: string = '';
  response: any;


  constructor(private otpService: InsLoginOtpService, 
    private router: Router,
    private route: ActivatedRoute,
    private _fuseConfigService: FuseConfigService,
    private toastr: ToastrService,
  ) {}

  ngAfterViewChecked(): void {
  // Scroll "Get OTP" button if mobile number valid
  if (this.isValidNumber && this.getOtpButton && !this.hasScrolledToButton) {
    this.getOtpButton.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.hasScrolledToButton = true;
  }

  // Scroll "Verify & Continue" button if OTP filled
  if ( this.otpFilled && this.verifyOtpButton && !this.hasScrolledToVerifyButton && document.activeElement?.tagName !== 'INPUT') {
    this.verifyOtpButton.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.hasScrolledToVerifyButton = true;
  }
}

 ngOnInit(): void {
  this._fuseConfigService.config = {
      layout: {
        navbar: { hidden: true },
        toolbar: { hidden: true },
        footer: { hidden: true },
        sidepanel: { hidden: true }
      }
    };
  this.quotationId = this.route.snapshot.paramMap.get('quotationid') || '';
  this.spareGarageId = this.route.snapshot.paramMap.get('sparegarageid') || '';

  // console.log('Quotation ID:', this.quotationId);
  // console.log('Spare Garage ID:', this.spareGarageId);

  // Check if the number is already logged in for this quotation
  const stored = localStorage.getItem(`insurance_loggedin_${this.quotationId}`);
  if (stored) {
    const data = JSON.parse(stored);
    const now = new Date().getTime();
    if (data.expiry > now) {
      // Valid logged-in session exists, navigate directly
      this.mobileNumber = data.mobile;
      this.router.navigate(['/insurance-approve-quotation/' +this.quotationId +'/'+ this.spareGarageId ]);
      return;
    } else {
      // Expired session, remove it
      localStorage.removeItem(`insurance_loggedin_${this.quotationId}`);
    }
  }
}


  ngOnDestroy(): void {
    this.stopTimer();
  }

  get isValidNumber(): boolean {
    return this.mobileNumber.length === 10;
  }

  get otpFilled(): boolean {
    return this.otp.every(x => x !== '');
  }

  getOtp() {
    if (!this.isValidNumber) {
      this.showError = true;
      return;
    }

    this.showError = false;

    this.otpService.sendOtp(this.mobileNumber).subscribe({
      next: (res) => {
        // console.log('OTP sent response:', res);
        this.otpSent = true;
        this.startTimer();
      },
      error: (err) => {
        console.error('Error sending OTP:', err);
        alert('Failed to send OTP. Please try again.');
      }
    });
  }

verifyOtp() {
  if (!this.otpFilled) {
    alert('Please enter the 4-digit OTP');
    return;
  }

  const otpString = this.otp.join('');

  this.otpService.validateOtp(this.mobileNumber, otpString).subscribe({
    next: (res) => {
      // console.log('OTP validation response:', res);

      if (res?.code === 200) {
        // Save login info for 24 hours
        this.response = res;
        // console.log("response of validate otp ",this.response);
        const authKey = this.response?.data?.authKey;
        const mobileNumber = this.response?.data?.mobile;

        if (authKey) {
          localStorage.setItem("authenticationKey", authKey);
          // console.log("✅ Authentication key stored successfully.");
        } else {
          console.error("❌ Authentication key not found in response:", this.response);
        } 
        if (mobileNumber) {
          localStorage.setItem("mobileNumber", mobileNumber);
          // console.log("✅ MobileNumber stored successfully.");
        }

        // Navigate to next page
        this.router.navigate([
          '/insurance-approve-quotation',
          this.quotationId,
          this.spareGarageId
        ]);
      } else {
        // alert(res?.message || 'OTP verification failed. Please try again.');
        this.toastr.error(res?.message || 'OTP verification failed. Please try again.');   
      }
    },
    error: (err) => {
      console.error('OTP validation failed:', err);
      alert('Invalid OTP. Please try again.');
    }
  });
}

  changeNumber() {
    this.otpSent = false;
    this.otp = ['', '', '', ''];
    this.stopTimer();
  }

  resendOtp() {
    this.timer = 60;
    this.getOtp(); // call API again on resend
  }

  startTimer() {
    this.stopTimer();
    this.interval = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
      } else {
        this.stopTimer();
      }
    }, 1000);
  }

  stopTimer() {
    if (this.interval) clearInterval(this.interval);
  }

  autoFocus(event: any, nextIndex: number) {
    if (event.target.value && nextIndex < 4) {
      const next = event.target.parentElement.children[nextIndex];
      if (next) next.focus();
    }
  }
  onOtpKeydown(event: KeyboardEvent, index: number) {
  const input = event.target as HTMLInputElement;

  if (event.key === 'Backspace') {
    // If current box has value → clear it only
    if (input.value) {
      this.otp[index] = '';
      return;
    }

    // If empty → move focus to previous box
    if (index > 0) {
      const prev = input.parentElement?.children[index - 1] as HTMLInputElement;
      prev?.focus();
      this.otp[index - 1] = '';
    }
  }
}

}
